import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/reducers/toasterSlice";
import { BannerService } from "../../../utils/api.service";
import { getStoreInfo } from "../../../utils/_hooks";
import { hideSpinner, showSpinner } from "../../../store/reducers/spinnerSlice";

export const useCustomizeShop = () => {
  const dispatch = useDispatch();
  const [currentCategory, setCurentCategory] = useState("Banners");
  const [state, setState] = useState({
    loaderStatus: false,
    banners: Array(6).fill(null),
  });

  useEffect(() => {
    getAllBanners();
  }, []);

  const getAllBanners = async () => {
    try {
      setState((prevState) => ({ ...prevState, loaderStatus: true }));
      const response = await BannerService.getAllBannersByRestaurantId(
        getStoreInfo()?._id
      );

      setState((prevState) => ({
        ...prevState,
        banners: response?.data?.banners,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setState((prevState) => ({ ...prevState, loaderStatus: false }));
    }
  };

  const handleCategorySelect = (category) => {
    setCurentCategory(category);
  };

  const uploadBanner = async (event, index) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (!file) {
      dispatch(
        showToast({
          type: "error",
          title: "File Not Found",
          message: "Please Select a File.",
        })
      );
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("index", index);

    try {
      dispatch(showSpinner());
      const response = await BannerService.uploadBanner(
        getStoreInfo()?._id,
        formData
      );

      if (response?.status === 200 || response?.status === 201) {
        dispatch(
          showToast({
            type: "success",
            title: "Success",
            message: "Banner uploaded successfully!",
          })
        );
        getAllBanners();
      }
    } catch (error) {
      dispatch(
        showToast({
          type: "error",
          title: "Error",
          message: "Error uploading banner.",
        })
      );
    } finally {
      dispatch(hideSpinner());
    }
  };

  const deleteBanner = async (bannerId, setShowModal) => {
    setShowModal(false);
    try {
      dispatch(showSpinner());
      const response = await BannerService.deleteBanner(bannerId);

      if (response?.status === 200 || response?.status === 201) {
        dispatch(
          showToast({
            type: "success",
            title: "Success",
            message: "Banner removed!",
          })
        );
        setState({ banners: [] });
        getAllBanners();
      }
    } catch (error) {
      dispatch(
        showToast({
          type: "error",
          title: "Error",
          message: "Error remove banner.",
        })
      );
    } finally {
      dispatch(hideSpinner());
    }
  };

  return {
    handleCategorySelect,
    state,
    uploadBanner,
    currentCategory,
    deleteBanner,
  };
};
